import type { ToastType } from './types.ts';

// Dashboard-local toast implementation — intentionally separate from the
// builder's own toast() (a pre-existing duplication in the legacy app that
// this port preserves rather than merges).
export function createToast(container: HTMLElement) {
  return function toast(msg: string, type: ToastType = 'info', dur = 3000): void {
    const el = document.createElement('div');
    el.className = 'toast' + (type === 'ok' ? ' ok' : type === 'err' ? ' err' : '');
    el.textContent = msg;
    const root = container.querySelector<HTMLElement>('#toast-root');
    root?.appendChild(el);
    setTimeout(() => el.remove(), dur);
  };
}
